export enum EMedAlertUi {
  WARNING = 'badge-warning',
  DANGER = 'badge-danger',
  SUCCESS = 'badge-success',
  INFO = 'badge-info',
}

export type TCurecallTagStatus = 'DANGER' | 'WARNING' | 'SUCCESS' | 'INFORMATION'

export const MED_ALERT_UI_TO_TAG_STATUS: Record<EMedAlertUi, TCurecallTagStatus> = {
  [EMedAlertUi.DANGER]: 'DANGER',
  [EMedAlertUi.WARNING]: 'WARNING',
  [EMedAlertUi.SUCCESS]: 'SUCCESS',
  [EMedAlertUi.INFO]: 'INFORMATION',
}

export type TMedAlert = {
  id: number
  ui: EMedAlertUi
  label?: string
  intlLabel?: Record<string, string>
  type: 'MEDICOLEGAL' | 'TODO' | 'INFO'
}

export type TPatientMedAlert = {
  id: number
  active?: boolean
  pinned?: boolean
  createdAt: string | Date
  MedAlertId?: number
  MedAlert: TMedAlert
  PatientId: number
  PatientMedEventId?: number
  PatientFollowupId?: number
}
